<template lang="pug">
  WtTile(vertical)
    WtTitle Overview
    WtTile(vertical)
      WtTile.overview-main-details
        WtEntityAvatar.mr-4(
          :image="logo"
          size-class="is-64x64"
          is-rounded
        )
        .p-1.mr-5
          p.has-text-grey.is-size-7 Created
          p.has-text-black.is-size-6(style="white-space:nowrap") {{ creationDateFormatted }}
        .p-1
          p.has-text-grey.is-size-7 Members
          p.has-text-black.is-size-6 {{ membersCount }}
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtEntityAvatar from "@@/WtEntityAvatar/WtEntityAvatar";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { mapGetters } from "vuex";

export default {
  name: "OrganizationOverview",

  components: {
    WtTitle,
    WtTile,
    WtEntityAvatar,
    WtRouterLink
  },

  mixins: [dateUtilityMixin],

  props: {
    logo: {
      type: String,
      default: null
    },
    creationDate: {
      type: String,
      default: null
    },
    membersCount: {
      type: Number,
      default: null
    }
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    creationDateFormatted() {
      if (this.creationDate) {
        return this.date(
          Date.parse(this.creationDate),
          "DATE_FORMAT_SHORT_MONTH"
        ).formatted;
      }
      return "";
    }
  }
};
</script>

<style lang="sass" scoped>
.card
  background-color: $grey-lighter
  width: 100%
  height: 75px
  padding: 6px 10px
.overview-main-details
  @media (max-width: 1100px)
    flex-direction: column
</style>
